import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import BlockTypes from '../../types/BlockTypes';
import renderBlocks from '../utils/renderBlocks';
import makeMarkdownBlockShortcut from '../utils/makeMarkdownBlockShortcut';
import makeToolbarButton, { EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import { SeparatorIcon } from '../../components/Icons';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import './style.css';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.SEPARATOR, {
    isVoid: true
  })
};
export default (function () {
  return [normalizeNode(BlockTypes.SEPARATOR, [shouldBeAtRoot]), _objectSpread({
    serializers: {
      html: _defineProperty({}, BlockTypes.SEPARATOR, function (_ref) {
        var attributes = _ref.attributes;
        return React.createElement("hr", attributes);
      }),
      markdown: _defineProperty({}, BlockTypes.SEPARATOR, function () {
        return "---\n";
      })
    }
  }, renderBlocks(_defineProperty({}, BlockTypes.SEPARATOR, function (props) {
    return React.createElement("hr", Object.assign({
      className: classNames('note-editor-separator', {
        'is-selected': props.isSelected
      }),
      contentEditable: false
    }, props.attributes));
  })), {
    schema: schema
  }), makeMarkdownBlockShortcut(/^(--)$/, BlockTypes.SEPARATOR, {
    triggers: ['-']
  }), makeMarkdownBlockShortcut(/^(---)$/, BlockTypes.SEPARATOR, {
    triggers: ['space', 'enter']
  }), makeToolbarButton(BlockTypes.SEPARATOR, {
    icon: SeparatorIcon,
    title: 'Separator',
    alias: ['hr'],
    visibility: EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.SEPARATOR);
    },
    onApply: function onApply(editor) {
      return editor.toggleBlock(BlockTypes.SEPARATOR);
    }
  })];
});